module.exports = __webpack_public_path__ + "img/dpd_logo.ed3a0fd6.svg";